import React, { useState } from 'react';

import HeroSection from './HeroSection/HeroSection';
import { withTranslation } from 'react-i18next';

const terms = [
  {
    id: 1,
    number: 'I.- ',
    title: 'TNC.FIRST.TITLE',
    descriptions: [
      { label: 'TNC.FIRST.DESCRIPTION.LABEL_ONE' },
      { label: 'TNC.FIRST.DESCRIPTION.LABEL_TWO' },
    ],
    active: false,
  },

  {
    id: 2,
    number: 'II.- ',
    title: 'TNC.SECOND.TITLE',
    descriptions: [
      { label: 'TNC.SECOND.DESCRIPTION.LABEL_ONE' },
      { label: 'TNC.SECOND.DESCRIPTION.LABEL_TWO' },
      { label: 'TNC.SECOND.DESCRIPTION.LABEL_THREE' },
      { label: 'TNC.SECOND.DESCRIPTION.LABEL_FOUR' },
    ],
    active: false,
    otherPoints: {
      title: 'TNC.SECOND.OTHER_POINTS.TITLE',
      points: [
        { label: 'TNC.SECOND.OTHER_POINTS.POINT_ONE' },
        { label: 'TNC.SECOND.OTHER_POINTS.POINT_TWO' },
        { label: 'TNC.SECOND.OTHER_POINTS.POINT_THREE' },
        { label: 'TNC.SECOND.OTHER_POINTS.POINT_FOUR' },
        { label: 'TNC.SECOND.OTHER_POINTS.POINT_FIVE' },
        { label: 'TNC.SECOND.OTHER_POINTS.POINT_SIX' },
        { label: 'TNC.SECOND.OTHER_POINTS.POINT_SEVEN' },
        { label: 'TNC.SECOND.OTHER_POINTS.POINT_EIGHT' },
        { label: 'TNC.SECOND.OTHER_POINTS.POINT_NINE' },
      ],
    },
  },
  {
    id: 3,
    number: 'III.- ',
    title: 'TNC.THIRD.TITLE',
    descriptions: [{ label: 'TNC.THIRD.DESCRIPTION.LABEL_ONE' }],
    active: false,
  },

  {
    id: 4,
    number: 'IV.- ',
    title: 'TNC.FOUR.TITLE',
    descriptions: [
      { label: 'TNC.FOUR.DESCRIPTION.LABEL_ONE' },
      { label: 'TNC.FOUR.DESCRIPTION.LABEL_TWO' },
      { label: 'TNC.FOUR.DESCRIPTION.LABEL_THREE' },
      { label: 'TNC.FOUR.DESCRIPTION.LABEL_FOUR' },
      { label: 'TNC.FOUR.DESCRIPTION.LABEL_FIVE' },
      { label: 'TNC.FOUR.DESCRIPTION.LABEL_SIX' },
						{ label: 'TNC.FOUR.DESCRIPTION.LABEL_SEVEN', link: 'kupos.cl' },
    ],
    active: false,
  },

  {
    id: 5,
    number: 'V.- ',
    title: 'TNC.FIVE.TITLE',
    // descriptions: [{ label: 'TNC.FIVE.DESCRIPTION.LABEL_ONE' }],
    active: false,
    otherPoints: {
      // title: 'TNC.FIVE.OTHER_POINTS.TITLE',
      points: [
        { label: 'TNC.FIVE.OTHER_POINTS.POINT_ONE' },
        { label: 'TNC.FIVE.OTHER_POINTS.POINT_TWO' },
        { label: 'TNC.FIVE.OTHER_POINTS.POINT_THREE' },
      ],
    },
  },

  {
    id: 6,
    number: 'VI.- ',
    title: 'TNC.SIX.TITLE',
    descriptions: [{ label: 'TNC.SIX.DESCRIPTION.LABEL_ONE' }],
    active: false,
    otherPoints: {
      // title: 'TNC.SIX.OTHER_POINTS.TITLE',
      points: [
        { label: 'TNC.SIX.OTHER_POINTS.POINT_ONE' },
        { label: 'TNC.SIX.OTHER_POINTS.POINT_TWO' },
        { label: 'TNC.SIX.OTHER_POINTS.POINT_THREE' },
        { label: 'TNC.SIX.OTHER_POINTS.POINT_FOUR' },
        { label: 'TNC.SIX.OTHER_POINTS.POINT_FIVE' },
        { label: 'TNC.SIX.OTHER_POINTS.POINT_SIX' },
        { label: 'TNC.SIX.OTHER_POINTS.POINT_SEVEN' },
      ],
    },
  },

  {
    id: 7,
    number: 'VII.- ',
    title: 'TNC.SEVEN.TITLE',
    // descriptions: [
    //     { label: 'TNC.SIX.DESCRIPTION.LABEL_ONE' },
    // ],
    active: false,
    otherPoints: {
      // title: 'TNC.SIX.OTHER_POINTS.TITLE',
      points: [
        { label: 'TNC.SEVEN.OTHER_POINTS.POINT_ONE' },
        { label: 'TNC.SEVEN.OTHER_POINTS.POINT_TWO' },
        { label: 'TNC.SEVEN.OTHER_POINTS.POINT_THREE' },
        { label: 'TNC.SEVEN.OTHER_POINTS.POINT_FOUR' },
        { label: 'TNC.SEVEN.OTHER_POINTS.POINT_SIX' },
        { label: 'TNC.SEVEN.OTHER_POINTS.POINT_SEVEN' },
        { label: 'TNC.SEVEN.OTHER_POINTS.POINT_EIGHT' },
        { label: 'TNC.SEVEN.OTHER_POINTS.POINT_NINE' },
      ],
    },
  },

  {
    id: 8,
    number: 'VIII.- ',
    title: 'TNC.EIGHT.TITLE',
    descriptions: [{ label: 'TNC.EIGHT.DESCRIPTION.LABEL_ONE' }],
    active: false,
    otherPoints: {
      title: 'TNC.EIGHT.OTHER_POINTS.TITLE',
      points: [
        { label: 'TNC.EIGHT.OTHER_POINTS.POINT_ONE' },
        { label: 'TNC.EIGHT.OTHER_POINTS.POINT_TWO' },
        { label: 'TNC.EIGHT.OTHER_POINTS.POINT_THREE' },
      ],
    },
  },

  {
    id: 9,
    number: 'IX.- ',
    title: 'TNC.NINE.TITLE',
    descriptions: [{ label: 'TNC.NINE.DESCRIPTION.LABEL_ONE' }],
    active: false,
  },
  {
    id: 10,
    number: 'X.- ',
    title: 'TNC.TEN.TITLE',
    descriptions: [
      { label: 'TNC.TEN.DESCRIPTION.LABEL_ONE' },
      { label: 'TNC.TEN.DESCRIPTION.LABEL_TWO' },
    ],
    active: false,
  },

  {
    id: 11,
    number: 'XI.- ',
    title: 'TNC.ELEVEN.TITLE',
    descriptions: [
      { label: 'TNC.ELEVEN.DESCRIPTION.LABEL_ONE' },
      { label: 'TNC.ELEVEN.DESCRIPTION.LABEL_TWO' },
      { label: 'TNC.ELEVEN.DESCRIPTION.LABEL_THREE' },
    ],
    bankDetails: [
      { label: 'TNC.ELEVEN.BANK_DETAILS.TITLE' },
      { label: 'TNC.ELEVEN.BANK_DETAILS.RECIPIENT' },
      { label: 'TNC.ELEVEN.BANK_DETAILS.RUTH' },
      { label: 'TNC.ELEVEN.BANK_DETAILS.BANK' },
      { label: 'TNC.ELEVEN.BANK_DETAILS.ACCOUNT' },
      { label: 'TNC.ELEVEN.BANK_DETAILS.EMAIL' },
    ],
    active: false,
    otherPoints: {
      title: 'TNC.ELEVEN.OTHER_POINTS.TITLE',
      points: [
        { label: 'TNC.ELEVEN.OTHER_POINTS.POINT_ONE' },
        { label: 'TNC.ELEVEN.OTHER_POINTS.POINT_TWO' },
        { label: 'TNC.ELEVEN.OTHER_POINTS.POINT_THREE' },
        { label: 'TNC.ELEVEN.OTHER_POINTS.POINT_FOUR' },
        { label: 'TNC.ELEVEN.OTHER_POINTS.POINT_FIVE' },
        { label: 'TNC.ELEVEN.OTHER_POINTS.POINT_SIX' },
        { label: 'TNC.ELEVEN.OTHER_POINTS.POINT_SEVEN' },
        { label: 'TNC.ELEVEN.OTHER_POINTS.POINT_EIGHT' },
        { label: 'TNC.ELEVEN.OTHER_POINTS.POINT_NINE' },
        { label: 'TNC.ELEVEN.OTHER_POINTS.POINT_TEN' },
        { label: 'TNC.ELEVEN.OTHER_POINTS.POINT_ELEVEN' },
        { label: 'TNC.ELEVEN.OTHER_POINTS.POINT_TWELVE' },
        { label: 'TNC.ELEVEN.OTHER_POINTS.POINT_THIRTEEN' },
        { label: 'TNC.ELEVEN.OTHER_POINTS.POINT_FOURTEEN', link: ' kupos.cl' },
      ],
    },
  },
];

const TnC = props => {
  const { t } = props;
  const [list, setList] = useState(terms);

  const handleToggle = item => {
    const data = JSON.parse(JSON.stringify(list));

    const updatedList = data.map(v => {
      if (v.id === item.id) {
        v.active = v.active ? false : true;
        return v;
      } else {
        v.active = false;
        return v;
      }
    });

    setList(updatedList);
  };
  const createMarkup = data => {
    return {
      __html: data,
    };
  };
  return (
    <div className="pages-terms-and-conditions">
      <div style={{ marginTop: '-30px' }}>
        <HeroSection
          title="Términos y condiciones"
          description="Home  /  Términos y condiciones"
          height="40vh"
          heroImage="/images/tnc/PullmanBus-TermsConditions-Banner.jpg"
        />
      </div>

      <div className="content-container">
        <div className="pullman-section-primary-row">
          <div className="pullman-section-primary-row-main-heading black-text margin-T30">
            {t('TNC.HEADING')}
          </div>
          <div className="pullman-section-primary-row-underline margin-B35"></div>
        </div>

        {list.map((val, i) => {
          return (
            <div className="single-item" key={i}>
              <div
                className={`header ${val.active ? 'hide-bg' : 'show-bg'}`}
                onClick={() => handleToggle(val)}
              >
                <span className="point-number">{val.number}</span>
                <span className="title black-text">{t(val.title)}</span>
                <img
                  className="arrow"
                  src={`/images/tnc/PullmanBus-TermsConditions-Arrow-${
                    val.active ? 'Up' : 'Down'
                  }.svg`}
                  alt=""
                />
              </div>

              {/* Selected Item */}
              {val.active ? (
                <div className="selected-item">
                  {/* Description  */}
                  {val.descriptions && val.descriptions.length > 0
                    ? val.descriptions.map((d, i) => {
                        return (
                          <div className="description" key={i}>
                            <span>
                              {t(d.label)}{' '}
                              {d.link && (
                                <a
                                  href="https://kupos.cl/es/pasajes/bus/pullman-bus"
                                  target="_blank"
                                >
                                  {d.link}
                                </a>
                              )}{' '}
                            </span>

                            <br />
                            <br />
                          </div>
                        );
                      })
                    : null}

                  {val.bankDetails && val.bankDetails.length > 0
                    ? val.bankDetails.map((d, i) => {
                        return (
                          <div className="" key={i}>
                            <span>{t(d.label)}</span>
                            <br />
                          </div>
                        );
                      })
                    : null}

                  {/* {val.bankDetails ? (
                    <div dangerouslySetInnerHTML={createMarkup(val.bankDetails)}></div>
                  ) : null} */}

                  {/* Other Points */}
                  <br />
                  {val.otherPoints ? (
                    <div className="other-points">
                      {val.otherPoints.title ? (
                        <div className="title">{t(val.otherPoints.title)}</div>
                      ) : null}
                      {val.otherPoints.points && val.otherPoints.points.length > 0
                        ? val.otherPoints.points.map((p, i) => {
                            return (
                              <div className="points-section">
                                <span className="number">{i + 1}. </span>
                                <span className="label">
                                  {t(p.label)}{' '}
                                  {p.link && (
                                    <a href="https://kupos.cl/" target="_blank">
                                      {p.link}
                                    </a>
                                  )}
                                </span>
                              </div>
                            );
                          })
                        : null}
                    </div>
                  ) : null}
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default withTranslation('common')(TnC);



// WEBPACK FOOTER //
// ./src/features/pages/TnC.js